export const environment = {
  production: true,
  mediaUrl: 'https://nes2-api-dev.portale-ict.it/nes',
  baseUrl: 'https://nes2-api-dev.portale-ict.it',
  basePDFServiceUrl: 'https://nes2-dev.pdf-service.portale-ict.it',
  baseExcelServiceUrl: 'https://nes2-dev.xlsreport-service.portale-ict.it',
  baseMailerServiceUrl: 'https://nes2-dev.email-service.portale-ict.it',
  version: '1.2.7',
  softwareName: 'NES 2',
};
